exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".link[data-v-26b4e5df] .avatar-uploader .el-upload {\n  width: 1.5625rem;\n  height: 0.833333rem;\n  border: 0.005208rem dashed #ddd;\n}\n.link[data-v-26b4e5df] .avatar {\n  width: 1.5625rem;\n  height: 0.833333rem;\n}", ""]);

// exports
